import { render, staticRenderFns } from "./v-checkbox-group.vue?vue&type=template&id=b3949726&scoped=true&"
import script from "./v-checkbox-group.vue?vue&type=script&lang=js&"
export * from "./v-checkbox-group.vue?vue&type=script&lang=js&"
import style0 from "./v-checkbox-group.vue?vue&type=style&index=0&id=b3949726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3949726",
  null
  
)

export default component.exports